export var ENTITY = "task";
export var REDUCER_KEY = "TASK_V2";
export var BASE_PATH_ENTITY = "tasks";
export var GENERATOR_PARAMS = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
    requestBodyToUtcWhitelist: ["nextReminderDate"],
};
